import React from 'react';
import PropTypes from 'prop-types';
import MarkdownRenderer from './MarkdownRenderer';

const ReportSummary = ({ summary }) => (
  <>
    <div className="breadcrumb-extra-row">
      <div className="breadcrumb-report">Report Summary:</div>
    </div>

    <div className="breadcrumb-report-box">
      <MarkdownRenderer content={summary} />
    </div>
  </>
);

ReportSummary.propTypes = {
  summary: PropTypes.string.isRequired,
};

export default ReportSummary;
